var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSadface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5417_22507)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2227 18.3807C20.0511 18.3807 20.7227 19.0523 20.7227 19.8807V22.8807H17.7227V19.8807C17.7227 19.0523 18.3943 18.3807 19.2227 18.3807Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6227 18.3807C28.4512 18.3807 29.1227 19.0523 29.1227 19.8807V22.8807H26.1227V19.8807C26.1227 19.0523 26.7943 18.3807 27.6227 18.3807Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4227 27.681C21.7659 27.681 20.4227 29.0241 20.4227 30.681H18.0227C18.0227 27.6987 20.4404 25.281 23.4227 25.281C26.4051 25.281 28.8228 27.6987 28.8228 30.681H26.4228C26.4228 29.0241 25.0796 27.681 23.4227 27.681Z",
    fill: "#A3A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7227 39.9811C32.3384 39.9811 39.3227 32.9967 39.3227 24.381C39.3227 15.7654 32.3384 8.78099 23.7227 8.78099C15.107 8.78099 8.12266 15.7654 8.12266 24.381C8.12266 32.9967 15.107 39.9811 23.7227 39.9811ZM23.7227 42.3811C33.6639 42.3811 41.7227 34.3222 41.7227 24.381C41.7227 14.4399 33.6639 6.38098 23.7227 6.38098C13.7816 6.38098 5.72266 14.4399 5.72266 24.381C5.72266 34.3222 13.7816 42.3811 23.7227 42.3811Z",
    fill: "#A3A1AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5417_22507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.380981)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadface);
export default __webpack_public_path__ + "static/media/sadface.1149fd9f.svg";
export { ForwardRef as ReactComponent };